export const ORG_TABS = {
  ABOUT: "About",
  GOALS: "Goals",
  TEAMSCAN: "TEAMscan",
  ORG_SETTINGS: "Organization Settings",
} as const;
